import { Link } from "@inertiajs/react";
import { useState } from "react";
import { useFlashToast } from "@/hooks/useFlashToast";
import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Label } from "@/components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { ArrowLeft, ScrollText } from "lucide-react";

const REPORT_LABELS: Record<string, string> = {
  boozes: "Booze",
  categories: "Categories",
  producers: "Producers",
};

type Props = {
  reports: string[];
  flash?: { notice?: string; alert?: string };
};

export default function GenerateReport({ reports, flash }: Props) {
  useFlashToast(flash);

  const [report, setReport] = useState("");

  return (
    <div className="py-8 px-4">
      <div className="mx-auto max-w-xl space-y-6">
        <Button variant="ghost" size="sm" asChild>
          <Link href="/">
            <ArrowLeft className="size-4" />
            Back to home
          </Link>
        </Button>

        <Card>
          <CardHeader>
            <div className="flex items-center gap-2">
              <ScrollText className="size-5 text-amber-600" />
              <CardTitle>Generate Report</CardTitle>
            </div>
            <CardDescription>
              Select a report type and download a CSV export immediately.
            </CardDescription>
          </CardHeader>
          <div>
            <CardContent className="space-y-4">
              <div className="space-y-2">
                <Label htmlFor="report">Report Type</Label>
                <Select value={report} onValueChange={setReport}>
                  <SelectTrigger id="report">
                    <SelectValue placeholder="Select a report type…" />
                  </SelectTrigger>
                  <SelectContent>
                    {reports.map((r) => (
                      <SelectItem key={r} value={r}>
                        {REPORT_LABELS[r] ?? r}
                      </SelectItem>
                    ))}
                  </SelectContent>
                </Select>
              </div>
            </CardContent>
            <CardFooter className="flex justify-end">
              <Button
                type="button"
                disabled={!report}
                onClick={() => {
                  const qs = new URLSearchParams({ report });
                  window.location.assign(`/reports/download?${qs.toString()}`);
                }}
              >
                Generate Report
              </Button>
            </CardFooter>
          </div>
        </Card>
      </div>
    </div>
  );
}
